export const rootElementId = 'root-create-montage';
export const rootElement = document.getElementById(rootElementId);

// Function to get user ID (either from data attributes or URL params)
export const getUserId = () => {
    return (
        rootElement.dataset.user ||
        new URLSearchParams(window.location.search).get("user")
    );
}

export function isDemoAccount(userId) {
    if (!userId) return false;
    console.log('[Utils] userId.includes freeaccount or Unregistered', userId.includes('freeaccount'), userId.includes('Unregistered'));
    // If 'free' or 'demo' exists in the userId string, it's treated as a free/demo account
    return userId.includes('freeaccount') || userId.includes('Unregistered');
}